import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TrStepInputComponent} from './tr-step-input.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { ElasticInputDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
        ReactiveFormsModule,
        FormsModule,
        CurrencyMaskModule,
        ElasticInputDirectiveModule,
    ],
    exports: [ TrStepInputComponent ],
    declarations: [ TrStepInputComponent ],
})
export class TrStepInputModule { }
